import { createPortal } from "react-dom";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to perform this action?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonClass = "btn-primary",
  icon = "fas fa-question-circle text-warning",
  /** Optional third action (e.g. "Only role") */
  altConfirmText = "",
  onAltConfirm,
  altConfirmButtonClass = "btn-outline-primary",
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 10000000 }}
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0 pb-2">
            <h5 className="modal-title d-flex align-items-center">
              <i className={`${icon} me-2`} />
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            {typeof message === "string" ? (
              <p className="mb-0">{message}</p>
            ) : (
              message
            )}
          </div>
          <div className="modal-footer border-0 flex-wrap gap-2">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              <i className="fas fa-times me-1" /> {cancelText}
            </button>
            {altConfirmText && typeof onAltConfirm === "function" ? (
              <button
                type="button"
                className={`btn ${altConfirmButtonClass}`}
                onClick={onAltConfirm}
              >
                {altConfirmText}
              </button>
            ) : null}
            <button
              type="button"
              className={`btn ${confirmButtonClass}`}
              onClick={onConfirm}
            >
              <i className="fas fa-check me-1" /> {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ConfirmModal;
